export default Object.freeze({

  YEAR: " año",
  MONTH: " mes",
  MONTHS: " meses",
  DAY: " día",
  HOUR: " hora",
  MINUTE: " minuto",
  SELECT_REPORT_TYPE: "Por favor seleccione al menos un canal para generar el informe.",

  /// ---------------------------- Menu Bar ---------------------------- 
  CHANNEL_1: "Canal 1",
  CHANNEL_2: "Canal 2",
  CHANNEL_3: "Canal 3",
  CHANNEL_4: "Canal 4",

  LIVE_LIST: "Live List",
  LIVE_LIST_MATRIX: "Matriz",
  OSCILLOSCOPE: "Osciloscopio",
  BAR_GRAPH: "Gráfico de barras",
  LOG: "Log",
  REPORT: "Informe",
  CONFIG: "Configuraciones",

  PORTUGUESE: "Portugués",
  ENGLISH: "Inglés",
  SPANISH: "Español",

  UPDATING_LANGUAGE_WAITING: "Cambiando idioma, por favor espere un momento",
  UNABLE_TO_ALTER_LANGUAGE: "No fue posible cambiar el idioma del programa.\n",

  // ---------------------------- Live List ----------------------------
  GOOD_STRING: "Bueno",
  ATTENTION_STRING: "Atención",
  BAD_STRING: "Malo",
  FAULT_STRING: "Falla",
  UNKNOWN_STRING: "Desconocido",

  LIVE_LIST_INPUT_TEXT_PLACEHOLDER: "Filtrar por dirección o señal",

  REASON_ASI: "Razón: ",

  REMOVE_POSITIONING: "Eliminar dispositivo en estado de falla",
  REMOVE_DEVICE_MODAL_CONTENT_1: "¿Estás seguro de que deseas eliminar el dispositivo?",
  REMOVE_DEVICE_SUCCESS: "El dispositivo se eliminará en el próximo escaneo.",
  REMOVE_DEVICE_FAILURE: "Ocurrió un error al eliminar el dispositivo: ",
  ADDRESS: "Dirección",
  AMPLITUDE: "Amplitud",
  DEVIATION: "Desvío",
  NOISE: "Ruido",
  STATUS: "Señal",
  FAULT: "Falla",
  RETRIES: "Reintentos",
  I0: "I0",
  I1: "I1",
  I2: "I2",
  I3: "I3",

  MILLIVOLT: "V",
  VOLTAGE: " V",
  VOLTAGE_PEAK_TO_PEAK: " V",
  A: "A",
  B: "B",
  MASTERS: "Maestros",
  SLAVES: "Esclavos",
  BAUD_RATE_KBPS: "BAUD RATE (Kbps)",
  CURRENT_CHANNEL: "Canal actual",

  NETWORK_DATA: "Datos de la red",

  DETECTED_PROBLEMS: "Problemas detectados:",
  INIT_PICO_NOT_FOUND: "TS Scope ASi ha detectado un error interno que le ha impedido funcionar correctamente. Reinicie TS Scope ASi. Si el problema persiste, comuníquese con Toledo & Souza para obtener ayuda.",
  MONGO_OFF: "TS Scope ASi ha detectado un error en su base de datos interna. Reinicie TS Scope ASi. Si el problema persiste, comuníquese con Toledo & Souza para obtener ayuda.",
  PICO_NOT_FOUND: "TS Scope ASi ha detectado un error interno que le ha impedido funcionar correctamente. Reinicie TS Scope ASi. Si el problema persiste, comuníquese con Toledo & Souza para obtener ayuda.",
  SCAN_FAIL_FOUND: "TS Scope ASi ha perdido la conexión a la red ASi, asegúrese de que esté conectado correctamente a la red. Después de conectarse, reinicie TS Scope ASi.",
  INVERTED_POLARITY_FOUND: "El TS Scope ASi detectó que los cables conectados tienen la polaridad invertida. Esto puede causar inestabilidad en la lectura de paquetes de red, provocando que esclavos inexistentes en la red aparezcan en la Live List. Para corregir este problema, vuelva a conectar los cables correctamente y reinicie el TS Scope ASi.",
  INVERTED_POLARITY: "Polaridad invertida",

  A_DEVICES: "Dispositivos A",
  B_DEVICES: "Dispositivos B",

  AMPLITUDE_POPUP_STR1: "Muestra la amplitud de la señal actual de cada dispositivo ASi en la red.",
  AMPLITUDE_POPUP_STR2: "El valor mínimo es 4 Vpp y el máximo es 8 Vpp.",
  NOISE_POPUP_STR: "El ruido en las redes ASi está limitado al 30% del valor de amplitud de la señal.",
  DEV_POPUP_STR1: "Indica el valor de desviación de la señal con respecto al oscilador de frecuencia, es decir, la relación temporal entre el punto donde la señal debería cruzar el cero y el punto donde realmente lo está cruzando.",
  DEV_POPUP_STR2: "Puede indicar un acoplamiento capacitivo al bus o incluso un problema de hardware.",
  DEV_POPUP_STR3: "Los límites son -0,8 μs a +1,6 μs.",
  RETRIES_POPUP_STR_1: "Los reintentos indican la cantidad de veces que se produjo una pérdida de paquetes y el maestro tuvo que volver a enviar una consulta a un dispositivo determinado.",
  RETRIES_POPUP_STR_2: "Los reintentos se calculan dentro de los buffers de adquisición de datos del monitor, que funcionan realizando adquisiciones a intervalos, alternando entre los 4 canales.",

  STATUS_POPUP_STR_1: "Calidad de la señal",
  STATUS_POPUP_STR_2: "• Amplitud de 4 a 8 V",
  STATUS_POPUP_STR_3: "• Amplitud de 2,5 a 4 V",
  STATUS_POPUP_STR_4: "• Amplitud menor que 2,5 V",
  STATUS_POPUP_STR_5: " o Amplitud superior a 8 V",
  STATUS_POPUP_STR_6: "• Indica que el esclavo ha dejado de comunicarse, es decir, ha dejado de intercambiar datos con el maestro (se ha desconectado de la red).",

  I_POPUP_STR: "Estas columnas muestran los bits de datos en las respuestas de los esclavos.",

  PS: "Nota:",

  CANCEL: "Cancelar",

  NO_ACTIVE_NETWORK: "TS Scope ASi no encontró una red activa, asegúrese de que esté conectado correctamente a una red ASi. Después de realizar la conexión, reinicie el TS Scope ASi.",

  CHANNEL_TAG_STR: "Tag del canal",
  MASTER: "Maestro",
  SLAVE: "Esclavo",

  TIME_ON: "Tiempo encendido:",

  // ---------------------------- Oscilloscope ----------------------------
  GRAPH: "Gráfico",
  WAVE_FORM: "Forma de onda",
  ADDRESS_DP: "Dirección: ",
  CHANNEL_DP: "Canal: ",
  WAVE_B_A: "Señal B - A",

  NANOSSECOND: "ns",
  MICROSSECOND: " µs",
  MILLISSECOND: " ms",

  TIME_NS: "Tiempo (ns)",
  TIME_US: "Tiempo (μs)",
  TIME_MS: "Tiempo (ms)",

  AMPLITUDE_PLACEHOLDER: "0,0 V",
  TIME_INTERVAL_PLACEHOLDER: "0,0 ",
  CURSORS: "Cursores",
  CONTROLS: "Controles ",
  TIME_INTERVAL: " tiempo",
  CONTROLS_POPUP_TEXT: "Después de presionar PLAY, la forma de onda se actualiza cada 2 segundos.",
  CONTROLS_POPUP_TEXT_2: "Para liberar los controles debes seleccionar la visualización manual y elegir un dispositivo.",

  VISUALIZATION: "Visualización",
  AUTOMATIC: "Automático",
  MANUAL: "Manual",

  KBPS: "Kbps",

  TIME_DP: "Tiempo: ",

  PS_1: "Nota 1:",
  PS_2: "Nota 2:",
  PS_3: "Nota 3:",

  // ---------------------------- Bar Graph ----------------------------
  ORDER_BY: "Ordenar por",
  AMPLITUDE_ASC: "Amplitud ascendente",
  AMPLITUDE_DESC: "Amplitud decreciente",
  ADDRESS_ASC: "Dirección ascendente",
  VOLTAGE_V: "Tensión (V)",
  VOLTAGE_V_PEAK_TO_PEAK: "Tensión (V)",
  LOADING: "Cargando",
  BAR_GRAPH_TYPE_PLACEHOLDER: "Seleccione un tipo de gráfico de barras",
  MICROSSECOND_TITLE: "Microsegundos (µs)",

  NOISE_ASC: "Ruido ascendente",
  NOISE_DESC: "Ruido decreciente",

  DEVIATION_ASC: "Desvío ascendente",
  DEVIATION_DESC: "Desvío decreciente",

  // ---------------------------- Log ----------------------------
  INSERT_VALID_ADDRESS_OR_TYPE: "Por favor ingresa una dirección válida o tipo de evento.",
  BEFORE_MONITOR_INIT_STR: "Antes del último inicio",
  LOG_INPUT_TEXT_PLACEHOLDER: "Filtrar por dirección o tipo de evento",
  LOG_WAITING: "Cargando datos del log de eventos",
  HORARY: "Tiempo",
  DESCRIPTION: "Descripción",
  TYPE: "Tipo",

  ASI_DEVIATION_LOG_DESCRIPTION: "TS Expert ha detectado una posible condición de desviación en la señal ASi.",
  ASI_ATTENUATED_SIGNAL_LOG_DESCRIPTION: "TS Expert ha detectado una posible condición de señal ASi atenuada.",
  ASI_NOISE_LOG_DESCRIPTION: "TS Expert ha detectado una posible condición de ruido en la red ASi.",
  ASI_NO_SIGNAL_LOG_DESCRIPTION: "TS Expert detectó que TS Scope ASi no pudo leer este esclavo en sus escaneos.",
  ASI_GENERAL_SIGNAL_LOSS_DESCRIPTION: "TS Scope ASi ha detectado una posible pérdida general de la señal ASi. Verifique si el cable se ha quitado del canal o si tiene mal contacto.",
  ASI_RETRY_LOG_DESCRIPTION: "TS Expert ha detectado una posible presencia de reintento.",
  ASI_FAULT_LOG_DESCRIPTION: "TS Expert ha detectado una posible condición de falla.",
  EVENT_CHECKED_SUCCESS: "El evento fue solucionado exitosamente.",

  // ---------------------------- Report ----------------------------
  REPORT_EXPORT_NAME: "Informe TS Scope ASi",

  HEADER_TEXT: "TS Scope ASi",
  GENERATE_REPORT: "Generar informe",

  GENERAL_REPORT: "Informe general – TS Scope ASi",
  DATA_REPORT: "Informe de datos – TS Scope ASi",

  CLIENT_INFO: "Información del cliente",
  EXECUTING_COMPANY_INFO: "Información de la empresa ejecutora.",
  CONFORMITY: "Conformidad",
  ANNOTATIONS: "Observaciones",
  CONCLUSION: "Conclusión",

  DROPDOWN_PLACEHOLDER: "Elija una opción",
  CONFORM: "Conforme",
  CONFORM_W_RESTRICTION: "Conforme con restriciones",
  NON_CONFORM: "No conforme",

  PROJECT_NAME: "- Nombre del proyecto:",
  NETWORK_NAME: "- Nombre de la red:",
  LOCATION: "- Localización:",
  COMPANY_NAME: "- Nombre de la empresa:",
  ACCOUNTABLE_NAME: "- Nombre del responsable:",
  COMPANY_ADDRESS: "- Dirección:",
  COMPANY_CITY: "- Ciudad:",
  COMPANY_TEL: "- Teléfono:",

  EXECUTING_COMPANY_NAME: "- Nombre de la empresa:",
  EXECUTING_ACCOUNTABLE_NAME: "- Nombre del responsable:",
  EXECUTING_TEL: "- Teléfono:",
  EXECUTING_EMAIL: "- E-mail:",

  ETHERNET_INFO: "Informaciones ETHERNET",

  IP_DP: "- IP: ",
  MASK_DP: "- Mascarilla: ",
  GATEWAY_DP: "- Gateway: ",

  NETWORK_NAME_DP: "- Nombre de la red: ",

  SUMMARY: "Índice",
  CHANNEL: "Canal",
  LIVE_LIST_PAGE_TITLE: "1 - Live List",
  OSCILLOSCOPE_PAGE_TITLE: "2 - Osciloscopio",
  BAR_GRAPH_PAGE_TITLE: "3 - Gráfico de barras",
  LOG_PAGE_TITLE: "4. - Log de eventos",

  LAST_200_EVENTS: "200 últimos eventos",

  PROTOCOL: "- Protocolo:",
  PROTOCOL_TYPE: "ASi",

  ANALYZER_VERSION_STRING: "- Versión TS Scope ASi:",
  ANALYSIS_INIT: "- Hora de inicio del análisis:",

  SOFTWARE_VERSION: "- Versión del software:",
  BAUD_RATE: "- Baud rate:",
  NUM_MASTERS: "- Maestros:",
  NUM_SLAVES: "- Esclavos:",

  LIVE_LIST_DOTS: ".....................................................................................................................................",
  BAR_DOTS: "......................................................................................................................",
  OSC_DOTS: ".............................................................................................................................",
  LOG_DOTS: ".............................................................................................................................................",
  DISCLAIMER_DOTS: ".................................................................................................................................",

  GENERATING_REPORT_WAITING: "Generando informe, por favor espere",

  SIGNAL_DP: "Señal: ",
  AMPLITUDE_DP: "Amplitud: ",
  DEVIATION_DP: "Desvío: ",
  NOISE_DP: "Ruido: ",

  END_OF_REPORT: "Fin del informe",
  DISCLAIMER: "Aviso legal",
  DISCLAIMER_TEXT: "Los datos y valores presentados en este informe son meramente auxiliares para el especialista ASi, por lo que cualquier indicación de corrección deberá ser realizada por el usuario. Por tal motivo, es recomendable contar con el apoyo de un ingeniero o técnico especialista responsable del análisis para confirmar la información proporcionada por el producto. Por tanto, Toledo & Souza queda exento de cualquier responsabilidad, pérdida o daño, directo o indirecto, causado por las interpretaciones del software, no ofreciendo garantía alguna respecto a la integridad, calidad o adecuación de la información facilitada, pues dependen del análisis técnico de un profesional cualificado, y en ausencia de éste, el usuario asumirá el riesgo de que el contenido sea inexacto, incompleto o no satisfaga sus necesidades y requisitos.",

  RETIES_DP: "Reintentos: ",
  I0_DP: "I0: ",
  I1_DP: "I1: ",
  I2_DP: "I2: ",
  I3_DP: "I3: ",

  // ---------------------------- Manage Information ----------------------------
  SAVE: "Guardar",
  REMOVE: "Remover",
  YES: "Sí",
  NO: "No",

  // ---------------------------- Configuration page related ----------------------------
  LOGIN: "LOGIN",
  ENTER: "Ingresar",
  LOGOUT: "Logout",
  RESTART_SYSTEM: "Reiniciar Sistema",
  IP: "IP",
  MASK: "Mascarilla",
  GATEWAY: "Gateway",
  TAG: "Tag",
  SETUP: "Configurar",
  EDIT: "Editar",
  SOFTWARE_UPDATE: "Actualización de software",
  INTERFACE_CONFIG: "Configuraciones de interfaz",
  CURRENT_VERSION: "Versión actual: ",
  UPDATE: "Actualizar",
  ALTER_LOGIN: "Cambiar login",
  ARE_YOU_SURE_ALTER_CONFIG: "¿Está seguro de que desea cambiar la configuración del TS Scope ASi?",
  INVALID_OR_CORRUPT_FILE: "El archivo no es válido o está dañado.",
  IMPORT: "Importar",
  EXPORT: "Exportar",
  LOGIN_CREDENTIALS_FAILURE: "Ocurrió un error al iniciar sesión: Nombre de usuario o contraseña incorrectos.",
  LOGIN_GENERAL_FALIURE: "Ocurrió un error al iniciar sesión:",

  GPG_ALERT_MESSAGE: "Sólo puedes enviar archivos con la extensión .gpg",
  GPG_FILE_EXTENSION: ".gpg",

  SEND_FILE_FAILURE: "Ocurrió un error durante el envío del archivo.",
  SEND_FILE_WAITING: "Enviando el archivo.",
  SEND_FILE_WRONG_FILENAME: "Nombre inválido. El archivo de actualización debe llamarse: updatePB.tar.gz.gpg",
  SEND_FILE_CORRUPTED_FILE: "El archivo de actualización se corrompió durante el envío.",
  SEND_CONFIG_FAILURE: "Ocurrió un error al enviar la configuración.",
  SEND_CONFIG_WAITING: "Enviando la configuración.",
  SEND_CONFIG_WAITING_2: "Finalizando el envío de la configuración.",
  SEND_CONFIG_DONE: "Configuraciones enviadas.",
  WAITING: "Por favor espere un momento",
  CLEAN_LOG_SUCCESS_1: "El log del 'Canal ",
  CLEAN_LOG_SUCCESS_2: "' fue limpiado exitosamente.",
  CLEAN_LOG_FAILURE: "Ocurrió un error al borrar el log.",
  CLEAR: "Limpiar",
  CHANGE_USERNAME_SUCCESS: "El nombre de usuario ha sido cambiado exitosamente. Por favor, inicie sesión nuevamente.",
  CHANGE_USERNAME_FAILURE: "Ocurrió un error al cambiar el nombre de usuario: ",
  USERNAME_TOO_SHORT: "El nombre de usuario debe contener al menos un carácter.",
  PASSWORD_MISSMATCH: "Las contraseñas ingresadas no coinciden",
  CHANGE_PASSWORD_SUCCESS: "La contraseña ha sido cambiada exitosamente Por favor, inicie sesión nuevamente.",
  CHANGE_PASSWORD_FAILURE: "Ocurrió un error al cambiar la contraseña: ",

  VERIFY_THE_FOLLOWING_INFO: "Por favor verifique la siguiente información:",
  INVALID_IP: "\n- La IP ingresada no es válida",
  INVALID_SUBMASK: "\n- La mascarilla ingresada no es válida",
  INVALID_GATEWAY: "\n- El gateway introducido no es válido.",
  INVALID_DNS: "\n- El DNS introducido no es válido.",
  LOOPBACK_IP: "\n- La IP de loopback (127.0.0.1) no se puede utilizar como IP del TS Scope ASi",
  LOOPBACK_IP_NTP: "\n-La IP de loopback (127.0.0.1) no se puede utilizar como IP del servidor NTP",
  TAG_TOO_LONG: "La longitud de la tag no puede exceder los 30 caracteres",
  SELECT_TIMEZONE: "\n- Debes seleccionar una Timezone para configurar el servidor NTP.",
  SUBNET_OVERLAP_WLAN: "\n- TS Scope ASi ha detectado que hay una superposición de direcciones entre la subred de la interfaz ETHERNET y la subred WLAN. Por este motivo, no es posible configurar la WLAN con la dirección IP y mascarilla elegidas.",
  SUBNET_OVERLAP_ETHERNET_WLAN: "\n- TS Scope ASi ha detectado que hay una superposición de direcciones entre la subred de la interfaz ETHERNET y la subred WLAN. Por este motivo, no es posible configurar la interfaz ETHERNET con la dirección IP y máscara elegidas.",
  ZERO_IP_MSG: "\n- La IP 0.0.0.0 no se puede utilizar como IP del TS Scope ASi",
  ZERO_IP_MASK_MSG: "\n- La IP 0.0.0.0 no se puede utilizar como mascarilla de red",
  BROADCAST_IP_MSG: "\n- La IP de broadcast de la red no se puede utilizar como IP del TS Scope ASi",
  NETWORK_IP_MSG: "\n- La IP de la red no se puede utilizar como IP del TS Scope ASi",
  BROADCAST_GATEWAY_MSG: "\n- La IP de broadcast de la red no se puede utilizar como IP del gateway.",
  NETWORK_GATEWAY_MSG: "\n-La IP de red no se puede utilizar como IP del gateway",

  CHOOSE_A_CHANNEL: "Para guardar la tag debes seleccionar un canal",

  ALTER_USERNAME: "CAMBIAR USUÁRIO",
  ALTER_PASSWORD: "CAMBIAR CONTRASEÑA",

  CONFIRM_RESTART_SYSTEM: "¿Está seguro de que desea reiniciar el sistema?",
  RESTART_SYSTEM_FAILURE: "Ocurrió un error al intentar reiniciar el sistema.",
  RESTART_SYSTEM_SUCCESS: "Solicitud de reinicio enviada exitosamente. Espere unos 3 minutos para que el sistema se reinicie por completo.",

  SELECT_FILE: "Por favor seleccione un archivo para enviar",

  DO_NOT_CLOSE_THIS_TAB: "Deje esta pestaña abierta para seguir la actualización.",
  UPDATING_MONITOR_FILES: "Actualizando archivos de TS Scope Ai. Espere por favor.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY: "Archivos actualizados, preparando el reinicio de TS Scope ASi.",
  RESTARTING_MONITOR_WAIT: "Reiniciando TS Scope ASi, espere unos minutos.",
  UPDATE_SUCCESS: "¡La actualización fue exitosa!",
  UPDATE_ERROR_STRING: "Ocurrió el siguiente error al actualizar TS Scope ASi: ",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS: "Modifique al menos uno de los campos para actualizar la configuración de la interfaz.",
  REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO: "\nRecuerde actualizar la dirección en su navegador a: ",
  UPDATE_INTERFACE_CONFIG_SUCCESS: "¡La configuración de la interfaz se ha actualizado con éxito!",

  ALTER: "Alterar",
  CHANNELS: "Canales",
  CHANNELS_TAGS: "Tags de los canales",
  DEVICES_TAGS: "Tags de los dispositivos",

  TAG_AND_NOTE_FROM_CHANNEL: "¡La tag del canal ",
  WAS_SUCCESSFULLY_ALTERED: " fue cambiada con éxito!",
  ALTER_TAG_ERROR: "Ocurrió un error al cambiar la etiqueta del canal ",
  ALTER_TAG_ERROR_REASON: ".\nRazón: ",
  ERROR_REASON: ".\nRazón: ",

  NOTE: "Observación",

  ETHERNET: "Ethernet",
  ETHERNET_POPUP_1: "Campo de configuración de la interfaz Ethernet.",
  ETHERNET_POPUP_2: "Utilizado para supervisión y acceso web a datos de TS Scope ASi.",

  WLAN: "WLAN",
  WLAN_POPUP_1: "Campo de configuración de la interfaz inalámbrica, cuando el adaptador esté disponible.",
  WLAN_POPUP_2: "Se utiliza para la supervisión y el acceso web a los datos de TS Scope ASi.",

  SEND_NTP_CONFIG_WAITING: "Enviando la configuración del servidor NTP.",

  NTP_SERVER: "Servidor NTP",

  TURN_NTP_SERVER_ON: "Activar el servidor NTP",
  TURN_NTP_SERVER_OFF: "Desactivar el servidor NTP",
  TURN_NTP_SERVER_ON_QUESTION: "¿Está seguro de que desea activar el servidor NTP? Para ello será necesario reiniciar el TS Scope ASi.",
  TURN_NTP_SERVER_OFF_QUESTION: "¿Está seguro de que desea desactivar el servidor NTP? Para ello será necesario reiniciar el TS Scope ASi.",

  PROCESSING_NTP_INIT: "Iniciando el procesamiento de información del servidor NTP.",
  PROCESSING_NTP_INFO: "Procesando información del servidor NTP.",
  PROCESSED_NTP_INFO: "Información del servidor NTP procesada.",
  PROCESSING_NTP_ERROR: "Ocurrió un error al enviar información al servidor NTP. Verifique si la dirección IP del servidor es correcta. Si es así, verifique también si el servicio NTP está activado e inténtelo nuevamente.",

  NTP_INFO_TURNED_ON_FAILURE: "Ocurrió un error al activar el servidor NTP.",
  NTP_INFO_FAILURE: "Error al sincronizar con el servidor. Si el error persiste, póngase en contacto con el administrador del servidor NTP.",

  MONITOR_RESTART_SUCCESS: "TS Scope ASi se ha reiniciado correctamente.",
  MONITOR_RESTART_FAILURE: "Ocurrió un error al reiniciar el TS Scope ASi.",

  NTP_INFO_TURNED_OFF_FAILURE: "Ocurrió un error al desactivar el servidor NTP.",

  TAG_WAS_CHANGED_SUCCESSFULLY: "La tag de TS Scope ASi ha sido modificada con éxito.",
  TAG_CHANGE_FAILURE: "Ocurrió un error al modificar la tag de TS Scope ASi.",

  TS_EXPERT_CONFIG_POPUP: "Le permite habilitar / deshabilitar las no conformidades que la herramienta reportará.",
  DNS: "DNS",

  USERNAME: "Usuario",
  NEW_PWD: "Nueva contraseña",
  REPEAT_PWD: "Repetir contraseña",

  TS_SCOPE_ASI_TAG: "Tag de TS Scope ASi",
  TEST_NETWORK: "Red de prueba",

  TS_SCOPE_ASI_REPORT_CHANNEL: "Informe TS Scope ASi - Canal",
  REPORTS_TS_SCOPE_ASI: "Informes - TS Scope ASi.zip",

  PROJECT_NAME_: "Nombre del proyecto",
  NETWORK_NAME_: "Nome da rede",
  LOCATION_: "Localización",
  COMPANY_NAME_: "Nombre de la empresa",
  RESPONSIBLE_NAME: "Nombre del responsable",
  ADDRESS_: "Ubicación",
  CITY: "Ciudad",
  TEL: "Teléfono",
  CLIENT_LOGO: "Logo del cliente",
  EMAIL: "E-mail",
  EXECUTING_COMPANY_LOGO: "Logo de la empresa ejecutora",
  CHANNELS_INCLUDED_REPORT: "Canales incluidos en el informe",

  // ---------------------------- Edit Tags page related ----------------------------
  ADD_ALTER_TAGS: "Agregar/Cambiar tags",
  CHOOSE_DEVICE: "Elija un dispositivo",
  NEW_TAG: "Nueva TAG",
  REMOVE_ALL_TAGS: "Eliminar todas las tags",
  CONFIRM_REMOVE_ALL_TAGS: "¿Está seguro de que desea eliminar las tags de todos los dispositivos?",
  CHANGE_TAG_SUCCESS: "La tag fue cambiada exitosamente",
  CHANGE_TAG_FAILURE: "Ocurrió un error al cambiar la etiqueta",
  REMOVE_TAG_SUCCESS: "Las etiquetas se han eliminado con éxito.",
  REMOVE_TAG_FAILURE: "Ocurrió un error al eliminar lag tags",
  IMPORT_TAGS_SUCCESS_1: "Las Tags del canal ",
  IMPORT_TAGS_SUCCESS_2: " fueron importadas con éxito",

  IMPORT_TAGS_FAILURE: "Ocurrió un error al importar las tags. ",
  PLEASE_SELECT_TAG_FILE: "Por favor seleccione un archivo de tags.",
  IMPORT_TAGS: "Importar tags",
  EXPORT_TAGS: "Exportar tags",

  CHOOSE_A_CHANNEL_FIRST: "Primero debes seleccionar un canal",
  CHOOSE_A_DEVICE_FIRST: "Primero debes seleccionar un dispositivo",

  EXPORT_TAGS_FILENAME: "tags-canal-",

  // ---------------------------- WLAN Config ----------------------------
  WLAN_STATUS: "Adaptador WLAN",
  WLAN_CONFIG: "Configuraciones WLAN",
  CONNECTION_STATUS: "Estado de la conexión",

  WLAN_ADAPTER_ON: "Encendido",
  WLAN_ADAPTER_OFF: "Apagado",

  IP_PLACEHODLER: "192.168.2.215",
  SSID: "SSID",
  SIGNAL_STRENGTH: "Fuerza de la señal",
  FREQUENCY: "Frecuencia",
  QUALITY: "Calidad",

  SSID_PLACEHOLDER: "SSID",
  MAC_PLACEHOLDER: "A0:8C:FD:19:DB:02",
  SIGNAL_STRENGTH_PLACEHOLDER: "90 dBm",
  FREQUENCY_PLACEHOLDER: "2.4GHz",
  CHANNEL_PLACEHOLDER: "1",
  QUALITY_PLACEHOLDER: "Calidad",

  TURNING_WLAN_OFF_WAITING: "Apagando el adaptador WLAN, por favor espere.",
  TURNING_WLAN_ON_WAITING: "Encendendo el adaptador WLAN, por favor espere.",

  NETWORK: "Red",
  NETWORK_NAME_1: "Nombre de la red",
  SUBMASK: "Macarilla",
  PASSWORD: "Contraseña",

  CONNECTED: "Conectada",
  DISCONNECTED: "Desconectada",

  WLAN_STATUS_POPUP_1: "Indica el estado del adaptador WLAN de TS Scope ASi.",
  WLAN_STATUS_POPUP_2: "Si está apagado, no es posible cambiar la configuración de WLAN.",

  CONNECTION_STATUS_POPUP_1: "Indica si el TS Scope ASi está conectado o no a la red WLAN configurada.",

  WLAN_CONFIG_POPUP_1: "No es posible cambiar la configuración mientras el adaptador WLAN está apagado.",
  WLAN_CONFIG_POPUP_2: "Se recomienda enfáticamente que la configuración de WLAN se cambie solo cuando se accede al monitor a través de la red cableada.",
  WLAN_CONFIG_POPUP_3: "Al cambiar la IP / mascarilla, si los campos aparecen en blanco después de la actualización, esto es una fuerte indicación de que:",
  WLAN_CONFIG_POPUP_4: "Ya hay otro dispositivo en la red con la misma IP;",
  WLAN_CONFIG_POPUP_5: "La mascarilla de red es muy estricta y no admite la IP que se pasó.",

  WLAN_ADAPTER_NOT_FOUND_1: "TS Scope ASi no pudo encontrar el adaptador WLAN:\n",
  WLAN_ADAPTER_NOT_FOUND_2: "  • Comproba si el adaptador está desconectado, o con mal contacto;\n",
  WLAN_ADAPTER_NOT_FOUND_3: "  • Si el adaptador no está desconectado o tiene mal contacto, intente reemplazarlo.;\n",
  WLAN_ADAPTER_NOT_FOUND_4: "  • Si ninguna de las opciones anteriores resuelve el problema, comuníquese con Toledo e Souza.",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN: "Modifique al menos uno de los campos para actualizar la configuración de WLAN.",
  UPDATE_WLAN_CONFIG_SUCCESS: "¡La configuración de WLAN se ha actualizado con éxito!",
  SEND_WLAN_CONFIG_WAITING: "Enviando la configuración, espere. Esto puede tardar aproximadamente un minuto.",
  LOADING_WAITING: "Cargando información, por favor espere.",
  WLAN_INFO: "Informaciónes WLAN",
  MAC: "MAC",

  UPDATE_WLAN_CONFIG_ERROR: "No es posible conectarse a la red WLAN. Si el problema persiste, intente reiniciar el TS Scope ASi o el enrutador WLAN.",

  HOSTNAME_POPUP_1: "Un hostname debe tener entre 2 y 64 caracteres para ser válido.",
  HOSTNAME_POPUP_2: "Además, solo puede contener letras, números, puntos y guiones, y debe comenzar y terminar solo con letras y números.",

  INVALID_HOSTNAME_1: "El hostname debe tener entre 2 y 64 caracteres.",
  INVALID_HOSTNAME_2: "El hostname debe contener solo letras, números, puntos y guiones, y debe comenzar y terminar solo con letras y números.",

  HOSTNAME_CONFIG_SUCCESS: "El hostname se ha configurado correctamente.",
  HOSTNAME_CONFIG_ERROR: "Ocurrió un error al configurar el hostname",
  MODE: "Modo",
  HIDDEN_SSID: "SSID Oculto",
  OPTIONAL: " (Opcional)",

  ALTER_MONITOR_WLAN_CONFIG: "¿Está seguro de que desea cambiar la configuración WLAN del TS Scope ASi?",

  FIXED_IP: "IP fija",

  // ---------------------------- TS EXPERT CONFIG ---------------------------- 
  SENDING_TS_EXPERT_CONFIG_WAITING: "Actualizando la configuración de TS Expert, espere un momento.",
  TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY: "La configuración de TS Expert se ha guardado con éxito.",
  TS_EXPERT_CONFIG_SAVE_ERROR: "Ocurrió un error al guardar la configuración de TS Expert.",
  TS_EXPERT_INVERTED_POLARITY_DISABLE_NOT_ALLOWED: "¡No es posible deshabilitar este evento!",

  TS_EXPERT_CONFIGURATION: "Configuración de TS Expert",
  ASI_ATTENUATED_SIGNAL_LIST_HEADER: "Señal atenuada",
  ASI_ATTENUATED_SIGNAL_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará al usuario una posible condición de señal ASi atenuada.",

  ASI_DEVIATION_LIST_HEADER: "Desvío",
  ASI_DEVIATION_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará al usuario una posible condición de desviación en la señal ASi.",

  ASI_NO_SIGNAL_LIST_HEADER: "Sin señal",

  ASI_NOISE_LIST_HEADER: "Ruido",
  ASI_NOISE_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará al usuario posibles condiciones de ruido en la red ASi.",

  ASI_GENERAL_SIGNAL_LOSS_HEADER: "Pérdida general de señal ASi",

  ASI_RETRY_LIST_HEADER: "Reintentos",
  ASI_RETRY_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará al usuario la posible presencia de reintentos.",

  ASI_FAULT_LIST_HEADER: "Falla",
  ASI_FAULT_LIST_CONTENT: "Cuando esta opción está habilitada, TS Expert indicará al usuario una posible condición de falla.",

  ASI_INVERTED_POLARITY_LIST_HEADER: "Polaridad invertida",
  ASI_INVERTED_POLARITY_LIST_CONTENT: "Cuando esta opción está habilitada, TS Expert indicará al usuario una posible condición de polaridad invertida.",

  // ---------------------------- TS EXPERT ----------------------------
  SCOPE_TAG: "Tag del Scope:",
  CHANNEL_TAG_2: "Tag del canal:",
  TS_EXPERT_REPORT_EXPORT_NAME: "Lista de acciones - TS Expert - TS Scope ASi",

  TS_EXPERT_POPUP_1: "Esta pestaña tiene como función exhibir informaciónes sobre el TS Expert.",
  TS_EXPERT_POPUP_2: "TS Expert es un sistema experto desarrollado para optimizar y acelerar el análisis de las principales divergencias detectadas por TS Scope ASi en redes ASi.",
  TS_EXPERT_POPUP_3: "De forma automatizada, los equipos de mantenimiento, ingeniería y afines pueden obtener un listado de acciones con los diferentes eventos, sus posibles causas, soluciones sugeridas y los dispositivos en los que fueron detectados.",
  TS_EXPERT_POPUP_4: "El uso de TS Expert no excluye la necesidad de análisis humano, ni reemplaza dichas capacidades para crear correlaciones e interpretación de datos.",

  TS_EXPERT: "TS Expert",
  DETECTED_ON: "Detectado en: ",
  CHECK_YOUR_NETWORK: "Por favor verifique su red.",

  EXPORT_ACTIONS_LIST: "Exportar lista de acciones",
  GENERATING_ACTIONS_LIST_WAITING: "Generando PDF de la lista de acciones, por favor espere.",
  GENERATING_ACTIONS_LIST_SUCCESS: "PDF generado exitosamente. Para guardarlo, haga clic en guardar lista de acciones.",

  EVENTS_LIST: "Lista de eventos",
  ACTIONS: "Acciones",

  NO_PROBLEM_DETECTED: "TS Expert no detectó ningún evento en la red.",
  NO_EVENTS_TO_BE_ANALYZED: "No existen eventos para analizar.",

  NO_EVENT_SELECTED: "No hay eventos seleccionados",
  CHOOSE_AN_EVENT: "Elija un evento para ver las acciones sugeridas.",

  DETAILING: "Detalles",

  CHECKED: "Conferido",
  BATCH_CHECK: "Conferir todos",

  PROBLEM_CHECKED: "El evento ha sido conferido con éxito",
  PROBLEM_CHECK_ERROR: "Ocurrió un error al conferir el evento.",

  LAST_UPDATED: "Actualizado por la última vez en: ",
  THIS_COMPUTER_TIME: " (Tiempo de esta computadora)",

  DEVICES: "Dispositivos",
  UNKNOWN: "Desconocido",

  ALL_EVENTS_WERE_CHECKED: "Todos los eventos han sido conferidos con éxito.",
  CHECK_EVENT_OBS: "\nEs importante tener en cuenta que algunos datos tardan hasta 15 minutos en actualizarse, por lo tanto, se sugiere esperar un tiempo para borrar esta lista haciendo clic en conferir.\n",

  UNABLE_TO_CHECK_DEVIATION_EVENTS: "No fue posible verificar los eventos de los siguientes dispositivos, ya que el TS Scope ASi continúa detectando una condición de jitter en la señal de la red ASi:\n",
  UNABLE_TO_CHECK_ATTENUATED_SIGNAL_EVENTS: "No fue posible verificar los eventos de los siguientes dispositivos, ya que el TS Scope ASi continúa detectando una señal con una amplitud inferior a 4 Vpp:\n",
  UNABLE_TO_CHECK_NOISE_EVENTS: "No fue posible verificar los eventos de los siguientes dispositivos, ya que el TS Scope continúa detectando una condición de ruido (amplitud superior al 30 % de la amplitud de la señal esclava):\n",
  UNABLE_TO_CHECK_RETRY_EVENTS: "No fue posible verificar los eventos de los siguientes dispositivos, ya que TS Scope ASi continúa detectando reintentos:\n",
  UNABLE_TO_CHECK_FAULT_EVENTS: "No fue posible verificar los eventos de los siguientes dispositivos porque TS Scope ASi sigue detectando una condición de falla:\n",
  UNABLE_TO_CHECK_INVERTED_POLARITY_EVENTS: "No fue posible verificar los eventos de los siguientes dispositivos porque TS Scope ASi sigue detectando una condición de polaridad invertida:\n",

  SAVE_ACTIONS_LIST: "Guardar lista de acciones",
  FINISHING: "Finalizando...",
  ACTIONS_LIST_SCOPE_CHANNEL: "Lista de acciones - TS Scope ASi - Canal",
  PAGE: "Página",

  // ---------------------------- DESVIO ----------------------------
  DEVIATION_SUGGESTION_1: "La alerta de “desviación” indica que TS Scope ASi ha encontrado una condición de jitter en la señal de red ASi en sus escaneos.",
  DEVIATION_SUGGESTION_2: "Verifique los siguientes elementos:",
  DEVIATION_SUGGESTION_3: "Aislamiento de equipos;",
  DEVIATION_SUGGESTION_4: "Humedad en el bus;",
  DEVIATION_SUGGESTION_5: "Problemas con la electrónica de los esclavos;",
  DEVIATION_SUGGESTION_6: "Oxidación en conexiones de los esclavos;",
  DEVIATION_SUGGESTION_7: "Oxidación en las conexiones de las junction box / barreras;",
  DEVIATION_SUGGESTION_8: "Cable largo.",

  // ---------------------------- SINAL ATENUADO ----------------------------
  ATTENUATED_SIGNAL_SUGGESTION_1: "La alerta de “señal atenuada” indica que TS Scope ASi encontró señales con una amplitud inferior a 4 Vpp en sus escaneos.",
  ATTENUATED_SIGNAL_SUGGESTION_2: "Realice las siguientes comprobaciones:",
  ATTENUATED_SIGNAL_SUGGESTION_3: "Si la electrónica esclava está interfiriendo con el bus, aislándola individualmente del bus;",
  ATTENUATED_SIGNAL_SUGGESTION_4: "Si existen puntos de alta resistencia como bornes flojos y cables aplastados.",
  ATTENUATED_SIGNAL_SUGGESTION_5: "Si la electrónica del gateway está interfiriendo con el bus, reemplácela por otra.",

  // ---------------------------- RUIDO ----------------------------
  NOISE_SUGGESTION_1: "La alerta de “ruido” indica que TS Scope ASi ha encontrado una condición de ruido en sus escaneos con una amplitud mayor al 30% de la amplitud de la señal esclava. ",
  NOISE_SUGGESTION_2: "A continuación tenemos 3 consejos para ayudar a resolver este problema:",
  NOISE_SUGGESTION_3: "Verifique el aislamiento de las interfaces de los esclavos, una forma sencilla es desconectarlas una a una de la red y verificar si el problema persiste.",
  NOISE_SUGGESTION_4: "Para atenuar el ruido, es necesario verificar que todos los esclavos de la red estén correctamente conectados a tierra;",
  NOISE_SUGGESTION_5: "Es necesario verificar la equipotencialización del sistema de puesta a tierra, una forma sencilla es verificar si existe corriente de fuga en los cables ASi. ",

  // ---------------------------- RETENTATIVAS ----------------------------
  RETRY_SUGGESTION_1: "Los reintentos indican la cantidad de veces que se produjo una pérdida de paquetes y el maestro tuvo que volver a enviar una consulta a un dispositivo determinado.",
  RETRY_SUGGESTION_2: "Los reintentos se calculan dentro de los buffers de adquisición de datos del monitor, que funcionan realizando adquisiciones a intervalos, alternando entre los 4 canales.",
  RETRY_SUGGESTION_3: "A continuación tenemos 3 consejos para ayudar a resolver este problema:",
  RETRY_SUGGESTION_4: "Compruebe si hay daños en el cable:",
  RETRY_SUGGESTION_5: "Verifique si hay cables de alimentación cerca de los cables ASi. Los cables de datos deben estar lo más separados posible o en bandejas/conductos cerrados y puestos a tierra, siguiendo el mínimo indicado por los lineamientos según la clasificación del conductor eléctrico, norma EN50174;",
  RETRY_SUGGESTION_6: "Si ninguno de los elementos anteriores resuelve el problema y un dispositivo específico experimenta reintentos aislados (solo un esclavo específico experimenta reintentos), se sugiere reemplazar el esclavo.",

  // ---------------------------- FALHA ----------------------------
  FAULT_SUGGESTION_1: "El estado Falla indica que el esclavo ha dejado de comunicarse, es decir, ha dejado de intercambiar datos con el maestro (se ha desconectado de la red).",
  FAULT_SUGGESTION_2: "En este caso no hay forma de determinar el motivo exacto de la falla, por lo que sugerimos:",
  FAULT_SUGGESTION_3: "Verifique la fuente de alimentación esclava;",
  FAULT_SUGGESTION_4: "Comprueba si estás conectado a la red (cable o fibra óptica);",
  FAULT_SUGGESTION_5: "Verificar la integridad y correcto montaje del conector;",
  FAULT_SUGGESTION_6: "Verifique la integridad del cable.",

  // ---------------------------- POLARIDADE INVERTIDA ----------------------------
  INVERTED_POLARITY_SUGGESTION_1: "El TS Scope ASi detectó que los cables conectados tienen la polaridad invertida. Esto puede causar inestabilidad en la lectura de paquetes de red, provocando que esclavos inexistentes en la red aparezcan en la Live List. Para corregir este problema, vuelva a conectar los cables correctamente y reinicie el TS Scope ASi.",

  // ---------------------------- EXPERT REPORT ----------------------------
  TS_EXPERT_DP: "TS Expert:",
  ACTIONS_LIST: "Lista de acciones",

  REPORT_GENERATION: "- Hora de generación del informe:",
  CHANNEL_TAG: "- Tag del canal: ",

  ASI_DEVIATION_PAGE_TITLE: ". - Desvío",
  ASI_ATTENUATED_SIGNAL_PAGE_TITLE: ". - Señal atenuada",
  ASI_NOISE_PAGE_TITLE: ". - Ruido",
  ASI_FAULT_PAGE_TITLE: ". - Falla",
  ASI_RETRY_PAGE_TITLE: ". - Reintentos",
  ASI_INVERTED_POLARITY_PAGE_TITLE: ". - Polaridad invertida",

  ASI_DEVIATION_DOTS: ".......................................................................................................................................",
  ASI_ATTENUATED_SIGNAL_DOTS: ".........................................................................................................................",
  ASI_NOISE_DOTS: ".........................................................................................................................................",
  ASI_FAULT_DOTS: "...........................................................................................................................................",
  ASI_RETRY_DOTS: ".................................................................................................................................",
  INVERTED_POLARITY_DOTS: "...................................................................................................................",
  DISCLAIMER_EXPERT_DOTS: ".................................................................................................................................",

  SUGGESTION: "Se sugiere",
  EVIDENCE: "Evidencias",
  EVIDENCE_DESCRIPTION: "Captura de evidencia de no conformidad reportado por el TS Expert:",

  ASI_DEVIATION_PAGE_DESCRIPTION: "TS Expert indica una posible desviación en la señal ASi.",
  ASI_ATTENUATED_SIGNAL_DESCRIPTION: "TS Expert indica una posible condición de señal ASi atenuada.",
  ASI_NOISE_DESCRIPTION: "TS Expert está indicando una posible condición de ruido en la red ASi.",
  ASI_FAULT_DESCRIPTION: "TS Expert está indicando una posible condición de falla.",
  ASI_RETRY_DESCRIPTION: "TS Expert está indicando una posible condición de reintento.",
  INVERTED_POLARITY_DESCRIPTION: "TS Expert está indicando una posible condición de polaridad inversa.",

  ASI_FAULT_DESCRIPTION_1: "En casos de falla, no se muestra la captura de evidencia de incumplimiento, ya que no existe señal ASi para analizar.",
  ASI_FAULT_DESCRIPTION_2: "Por tal motivo, a continuación se muestra una tabla con todos los dispositivos cuyas señales no fueron detectadas, sus respectivos canales y el momento en que se detectó el problema.",

  ASI_RETRY_DESCRIPTION_1: "En los casos de reintentos no se muestra la captura de evidencia del incumplimiento.",
  ASI_RETRY_DESCRIPTION_2: "Por tal motivo, a continuación se muestra una tabla con todos los dispositivos cuyas señales no fueron detectadas, sus respectivos canales y el momento en que se detectó el problema.",

  // ---------------------------- ACTIVE CHANNELS ----------------------------
  ACTIVE_CHANNELS: "Canales activos",
  ACTIVE_CHANNELS_POPUP_1: "Le permite configurar qué canales TS Scope ASi están actualmente activos (qué canales se utilizarán).",
  ACTIVE_CHANNELS_POPUP_2: "Se recomienda deshabilitar todos los canales que no se estén utilizando actualmente.",
  SAVING_ACTIVE_CHANNELS: "Guardando canales activos, por favor espere.",
  SEND_ACTIVE_CHANNELS_SUCCESS: "¡Los canales activos se han guardado correctamente!\nDespués de presionar OK, será redirigido a la página de inicio de TS Scope ASi.",
  SEND_ACTIVE_CHANNELS_ERROR: "Ocurrió un error al guardar los canales activos.",
  CANT_TURN_ALL_CHANNELS_OFF: "No es posible desactivar todos los canales TS Scope ASi al mismo tiempo.\n\nAl menos uno de los canales debe permanecer activo.",

  // ---------------------------- ASI NETWORK VERSION ----------------------------
  ASI_NETWORK_VERSION: "Versión de red ASi",
  ASI_NETWORK_VERSION_2: "Versión 2.0",
  ASI_NETWORK_VERSION_2_1: "Versión 2.1",
  ASI_NETWORK_VERSION_POPUP_1: "Permite configurar la versión de la red ASi monitoreada por cada uno de los canales ASi de TS Scope.",
  ASI_NETWORK_VERSION_POPUP_2: "Las redes ASi que utilizan el protocolo versión 2.0 admiten hasta 32 dispositivos por red, direccionados del 1 al 32.",
  ASI_NETWORK_VERSION_POPUP_3: "Las redes ASi que utilizan el protocolo versión 2.1 o superior admiten hasta 64 dispositivos, direccionados de 1A a 32A y de 1B a 32B.",
  DISABLED_CHANNELS_POPUP_1: "Algunos canales pueden aparecer como deshabilitados en esta pantalla y no se puede modificar la versión de la red ASi.",
  DISABLED_CHANNELS_POPUP_2: "Esto ocurre cuando están apagados, para modificar la versión de red del canal vaya a la pantalla de configuración del canal y habilítelos.",
  SEND_ASI_TYPE_SUCCESS_1: "La versión en red del 'Canal ",
  SEND_ASI_TYPE_SUCCESS_2: "' se guardó exitosamente!",
  SEND_ASI_TYPE_ERROR: "Ocurrió un error al guardar la versión de red del 'Canal ",

  // ---------------------------- LOADING ----------------------------
  INITIALIZING_SCOPE_DP: "Inicializando TS Scope ASi, por favor espere."

});